import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07a143f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calculation" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "bg-white border px-6 py-4 flex items-center justify-center"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "px-6 py-4 bg-white border" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Общая информация", -1))
const _hoisted_11 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start mt-3" }
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Компания", -1))
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Тариф", -1))
const _hoisted_16 = { class: "grid" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Номер накладной", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-6" }, "Параметры накладной", -1))
const _hoisted_19 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start mt-3" }
const _hoisted_20 = { class: "grid" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Зона", -1))
const _hoisted_22 = { class: "grid" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Физический вес", -1))
const _hoisted_24 = { class: "grid" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Объемный вес", -1))
const _hoisted_26 = { class: "grid" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Тип перевозки", -1))
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Направление", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-6" }, "Стоимость основных услуг", -1))
const _hoisted_31 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start mt-3" }
const _hoisted_32 = { class: "grid" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Стоимость доставки", -1))
const _hoisted_34 = { class: "grid" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Стоимость за упаковку", -1))
const _hoisted_36 = { class: "grid" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Сумма за страхование", -1))
const _hoisted_38 = { class: "grid" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Сумма за выгрузку", -1))
const _hoisted_40 = { class: "grid" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Стоимость оформления заказа", -1))
const _hoisted_42 = { class: "grid" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Топливный сбор", -1))
const _hoisted_44 = { class: "grid" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Страховой сбор", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-6" }, "Стоимость дополнительных услуг", -1))
const _hoisted_47 = {
  key: 0,
  class: "text-sm mt-3"
}
const _hoisted_48 = {
  key: 1,
  class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start mt-3"
}
const _hoisted_49 = {
  key: 0,
  class: "grid"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Мягкая упаковка", -1))
const _hoisted_51 = {
  key: 1,
  class: "grid"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Обрешетка", -1))
const _hoisted_53 = {
  key: 2,
  class: "grid"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Грузчики", -1))
const _hoisted_55 = {
  key: 3,
  class: "grid"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Паллетирование", -1))
const _hoisted_57 = {
  key: 4,
  class: "grid"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Кран", -1))
const _hoisted_59 = {
  key: 5,
  class: "grid"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Манипулятор", -1))
const _hoisted_61 = {
  key: 6,
  class: "grid"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Рохля", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-6" }, "Итого", -1))
const _hoisted_64 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start mt-3" }
const _hoisted_65 = { class: "grid" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Самовывоз", -1))
const _hoisted_67 = { class: "grid" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Самопривоз", -1))
const _hoisted_69 = { class: "grid" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Сумма платежа к оплате", -1))
const _hoisted_71 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: `Подробная информация о вычислении (ID: ${_ctx.calculation_id})`
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        (Boolean(_ctx.state.calculation) && Boolean(_ctx.state.calculation.transcriptId))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "mr-3",
              target: "_blank",
              to: `/billing/transcripts/${_ctx.state.calculation.transcriptId}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, { class: "primary text small" }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createTextVNode(" Показать транскрипт ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_button, {
          class: "second text small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/billing')))
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.is_loading && !_ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_loader, { class: "primary" })
          ]))
        : (_ctx.state.is_failed)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 1,
              loading: _ctx.state.is_loading,
              text: `При получении вычисления произошла ошибка`,
              onRefresh: _ctx.loadCalculation
            }, null, 8, ["loading", "onRefresh"]))
          : (Boolean(_ctx.state.calculation))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.company), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.tariff), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_router_link, {
                        class: "text-blue-500",
                        to: `/invoice/${_ctx.state.calculation.invoiceId}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.state.calculation.invoiceNumber), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]),
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.zone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.weight) + " кг", 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.volumeWeight) + " кг", 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.shipmentType || 'Нет данных'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.direction || 'Нет данных'), 1)
                    ])
                  ]),
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.deliveryCharge) + " ₸", 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.packageCharge) + " ₸", 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.insuranceCharge) + " ₸", 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.unloadCharge) + " ₸", 1)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.orderCharge) + " ₸", 1)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.standardParamValue.fuelPercent * 100) + " %", 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.standardParamValue.inscostPercent * 100) + " %", 1)
                    ])
                  ]),
                  _hoisted_46,
                  (_ctx.isAllAdditionalServicesEmpty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Нет дополнительных услуг "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        (Boolean(_ctx.state.calculation.additionalServiceValue.softPackageCost))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _hoisted_50,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.softPackageCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (Boolean(_ctx.state.calculation.additionalServiceValue.gridCost))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.gridCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (Boolean(_ctx.state.calculation.additionalServiceValue.loaderCost))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _hoisted_54,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.loaderCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (Boolean(_ctx.state.calculation.additionalServiceValue.palletCost))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.palletCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (Boolean(_ctx.state.calculation.additionalServiceValue.craneCost))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _hoisted_58,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.craneCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (Boolean(_ctx.state.calculation.additionalServiceValue.manipulatorCost))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _hoisted_60,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.manipulatorCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                                Boolean(
                                    _ctx.state.calculation.additionalServiceValue.hydraulicTrolleyCost
                                )
                            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.additionalServiceValue.hydraulicTrolleyCost) + " ₸ ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])),
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.standardParamValue.pickupPercent) + " %", 1)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.calculation.standardParamValue.selfDeliveryPercent) + " %", 1)
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _hoisted_70,
                      _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.state.calculation.finalPaymentAmount) + " ₸", 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}